// @flow
import * as React from 'react';
import styled from 'styled-components';
import { Link as RouterLink } from 'components/RouterLink';
import Link from 'components/Link';
import { SmallTile } from 'components/Tile';
import { transition, colors } from '../theme';

export const OverlayRouterLink = styled(RouterLink)`
  &,
  &:active,
  &:visited {
    color: inherit;
    text-decoration: none;
  }
  ::after {
    z-index: 0;
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
`;

export const OverlayLink = styled(Link)`
  &,
  &:active,
  &:visited,
  &:hover {
    color: inherit;
    text-decoration: none;
  }
  ::after {
    z-index: 0;
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
`;

export const HoverEffect = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  overflow: hidden;
  border-radius: 4px 0 0 4px;
  &::before {
    content: '';
    width: 100%;
    height: 100%;
    display: block;
    background: linear-gradient(to left, #f7fc26, #f9de09);
    transition: all ${transition};
  }
`;

const SearchTile = styled(
  ({ children, ...props }: { children?: React.Node }) => (
    <SmallTile {...props}>
      <HoverEffect />
      {children}
    </SmallTile>
  )
)`
  overflow: visible;
  ${props =>
    !props.disabled
      ? `
  cursor: pointer;
  ${HoverEffect} {
    &::before {
      transform: translateY(-100%);
    }
  }
  &:hover,
  &:focus {
    ${HoverEffect} {
      &::before {
        transform: translateY(0);
      }
    }
  }`
      : `
    background: transparent;
    box-shadow: 0 0 0 1px ${colors.aluminum};
  `}
`;

export default SearchTile;
